import { ResourceOptions } from 'react-admin';
import { MdOutlineLink } from 'react-icons/md';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.xpxPerpsChainConfigs;
export const icon = MdOutlineLink;
export const options: ResourceOptions = {
  label: 'module.xpxPerpsChainConfigs.title',
};
